//Data for VAC-IKS Website

export const siteConfig = {
  siteName: "Vidushi Arundhati Centre for Indian Knowledge Systems",
  shortName: "VAC-IKS",
  motto: "सत्यं ज्ञानमनन्तं ब्रह्म",
  mottoTranslation: "Truth, Knowledge, and Infinity are the essence of Brahman",
  tagline: "Bridging Ancient Wisdom with Modern Innovation",
  college: "Maitreyi College, University of Delhi",
  email: "iks@maitreyi.du.ac.in",
  phone: "+91-9311-331434",
  phone2: "+91-8178-275227",
  address: "IKS Office, NSB-4, Maitreyi College, BapuDham Complex, Chanakyapuri, New Delhi - 110021",
  socialMedia: {
    // youtube: "#",
    // facebook: "#",
    // twitter: "#",
    // instagram: "#",
    // linkedin: "#"
  }
};

// running tab 
export const latestUpdates = [
  {
    text: "Gyanotsava 2026: Competition Guidelines Now Available",
    link: "/assets/Guidelines-for-Gyanotsava.pdf",
    type: "pdf",
    isNew: true
  },
  {
    text: "GYANOTSAVA 2026 – Step Into the World of Indian Knowledge Systems",
    link: "/assets/VAC-IKS-GYANOTSAVA-2026.pdf",
    type: "pdf",
    isNew: true
  },
  {
    text: "Call for Papers Open – Submit before April 30, 2026",
    link: "/publications",
    type: "page",
    isNew: true
  },
  {
    text: "First Meeting of Selected Interns – VAC-IKS Student Internship Programme (Jan–June 2026)",
    isNew: true,
    link: "/activities",
    type: "notice"
  },
  {
    text: "Admissions open for IKS Certificate Course 2025",
    isNew: false,
    link: "/academics"
  },
  {
    text: "International Conference on Indian Knowledge Systems – Feb 2025",
    isNew: false,
    link: "/academics"
  },
  {
    text: "Faculty Development Programme on IKS – January 2025",
    isNew: false,
    link: "/academics"
  }
];


export const heroContent = {
  title: "Vidushi Arundhati Centre for Indian Knowledge Systems",
  subtitle: "A globally recognized Centre of Excellence nurturing education and research rooted in India's timeless wisdom, dynamically engaged with modern challenges",
  announcement: "Now Accepting Applications for 2025-26",
  ctaButtons: [
    { text: "Become an Intern", link: "/work-with-us#intern" },
    { text: "Volunteer", link: "/work-with-us#volunteer" },
    { text: "Explore Research", link: "/academics" }
  ]
};

export const aboutContent = {
  introduction: `The Vidushi Arundhati Centre for Indian Knowledge Systems (VAC-IKS) is an advanced interdisciplinary center at Maitreyi College, University of Delhi. Our core mission is to rediscover, critically evaluate, and innovatively apply India's civilizational wisdom (Indian Knowledge Systems - IKS) in contemporary education and research.`,

  inspiration: {
    title: "Inspiration: Vidushi Arundhati",
    description: "Named after the legendary Vedic scholar Arundhati, renowned for her wisdom and intellectual prowess, our Centre embodies the spirit of inquiry, knowledge, and truth. Arundhati represents the highest ideals of learning and ethical living in Indian tradition."
  },

  vision: "To become a globally recognized Centre of Excellence, dedicated to nurturing an education and research culture rooted in India's timeless wisdom while being dynamically engaged with the challenges of the modern world. We promote value-based knowledge, sustainable innovation, and intellectual harmony.",

  mission: [
    "Revival and reinterpretation of Indian Knowledge Systems through critical research",
    "Integration of IKS principles into modern academic curricula aligned with NEP 2020",
    "Promotion of interdisciplinary research bridging classical and contemporary domains",
    "Nurturing ethical, value-based, and socially responsible education",
    "Community engagement through outreach programs and practical applications",
    "Advancement in digital humanities, computational linguistics, and Vedic mathematics",
    "Global collaboration for disseminating IKS knowledge worldwide"
  ],

  coreValues: [
    { value: "Truth (Satya)", icon: "Sparkles" },
    { value: "Knowledge (Jnana)", icon: "BookOpen" },
    { value: "Integrity", icon: "Shield" },
    { value: "Innovation", icon: "Lightbulb" },
    { value: "Sustainability", icon: "Leaf" },
    { value: "Inclusivity", icon: "Users" }
  ],

  nep2020: "VAC-IKS is meticulously aligned with the National Education Policy (NEP) 2020, emphasizing holistic and multidisciplinary learning, undergraduate research, and the integration of Indian knowledge systems into mainstream education."
};

export const teamMembers = {
  patron: {
    name: "Hon'ble Chairperson",
    designation: "Patron",
    organization: "Governing Body, Maitreyi College"
  },

  leadership: [
    {
      name: "Prof. Haritma Chopra",
      designation: "Founder, Chairperson and Director",
      role: "Principal, Maitreyi College",
      description: "Provides strategic leadership, academic vision, and institutional guidance",
      image: null
    },
    {
      name: "Prof. Jyoti Singh",
      designation: "Deputy Director",
      role: "Vice Principal, Maitreyi College",
      description: "Oversees day-to-day functioning and assists in academic and research matters",
      image: null
    },
    {
      name: "Dr. Pramod Kumar Singh",
      designation: "Coordinator & Nodal Officer",
      role: "Associate Professor, Department of Sanskrit",
      description: "Responsible for executing plans and ensuring smooth functioning",
      image: null
    }
  ],

  coreTeam: [
    { name: "Dr. Dharmendra Kumar", department: "Sanskrit", image: null },
    { name: "Dr. Tejendra Kumar", department: "Zoology", image: null },
    { name: "Dr. Neelima Ohri", department: "Mathematics", image: null },
    { name: "Dr. Sonal Babbar", department: "Commerce", image: null },
    { name: "Dr. Smriti Singh", department: "English", image: null },
    { name: "Dr. Anamika Singh", department: "Botany", image: null },
    { name: "Dr. Anita Devi", department: "Hindi", image: null },
    { name: "Dr. Kumud Rani Garg", department: "Sanskrit", image: null },
    { name: "Ms. Nupur Chawla", department: "English", image: null },
    { name: "Dr. Akash Pratap", department: "Botany", image: null }
  ]
};

export const academicPrograms = [
  {
    id: "addon",
    title: "Annual Academic Fest",
    duration: "13–14 April 2026",
    credits: null,
    name: "GYANOTSAVA 2026",
    description: "An Annual Academic Fest of VAC-IKS featuring Debate, Creative Writing, and UG Olympiad competitions aligned with Indian Knowledge Systems.",
    curriculum: [
      "Vāda-Vidyā (Debate)",
      "Bhāva-Pravāha (Creative Writing)",
      "IKS Heritage Insights (UG Olympiad)"
    ],
    eligibility: "UG students from all streams (Arts, Commerce & Science)",
    pdfLink: "/assets/VAC-IKS-GYANOTSAVA-2026.pdf",
    guidelineLink: "/assets/Guidelines-for-Gyanotsava.pdf"
  },
  // {
  //   id: "addon",
  //   title: "Add-on Course",
  //   duration: "6 Months",
  //   credits: "12 Credits",
  //   name: "IKS and Contemporary Society",
  //   description: "Explores the relevance of Indian knowledge systems in addressing modern challenges across various disciplines.",
  //   curriculum: [
  //     "IKS in Modern Education",
  //     "Ancient Wisdom and Sustainability",
  //     "Indian Psychology and Cognitive Science",
  //     "Comparative Philosophy"
  //   ],
  //   eligibility: "Undergraduate students from any discipline"
  // },
  {
    id: "certificate",
    title: "Certificate Course",
    duration: "3 Months",
    credits: null,
    name: "Foundations of Indian Knowledge Systems",
    description: "An introductory program covering the essential principles and concepts of IKS, suitable for beginners.",
    curriculum: [
      "Introduction to Vedas and Upanishads",
      "Basics of Indian Philosophy",
      "Overview of Sanskrit Language",
      "Ancient Indian Sciences"
    ],
    eligibility: "Open to all undergraduate students"
  },
  {
    id: "diploma",
    title: "Diploma in IKS",
    duration: "1 Year",
    credits: null,
    name: "Bridging Tradition and Modernity",
    description: "A comprehensive program that deeply integrates classical Indian knowledge with contemporary research and applications.",
    curriculum: [
      "Advanced Sanskrit Studies",
      "Vedic Mathematics",
      "Ayurveda and Yoga Philosophy",
      "Digital Humanities and IKS",
      "Research Methodology",
      "Capstone Project"
    ],
    eligibility: "Graduates in any discipline"
  },
  {
    id: "elective",
    title: "Elective/Minor Course",
    duration: "1 Semester",
    credits: "4 Credits",
    name: "Introduction to Indian Knowledge Systems",
    description: "An elective course for students across disciplines to gain exposure to IKS principles.",
    curriculum: [
      "Overview of Indian Philosophical Schools",
      "Indian Science and Mathematics",
      "Art, Culture and Aesthetics",
      "Applied IKS in Modern Context"
    ],
    eligibility: "All undergraduate students"
  }
];

export const researchAreas = [
  {
    title: "Philosophy and Ethics",
    description: "Exploring Vedānta, Nyāya, Sāmkhya, Buddhist philosophy and comparative philosophical studies",
    icon: "Brain"
  },
  {
    title: "Indian Sciences",
    description: "Research in Ayurveda, Yoga, Astronomy, Mathematics, Metallurgy, and Agricultural knowledge",
    icon: "Microscope"
  },
  {
    title: "Governance and Law",
    description: "Studying Arthaśāstra, Dharmaśāstra, and Indian jurisprudential thought",
    icon: "Scale"
  },
  {
    title: "Aesthetics and Linguistics",
    description: "Analysis of Nātyaśāstra, Alańkāraśāstra, and Pāņinian linguistic systems",
    icon: "Music"
  },
  {
    title: "Environment and Sustainability",
    description: "Ancient ecological wisdom and its application to modern environmental challenges",
    icon: "Leaf"
  },
  {
    title: "Digital Humanities",
    description: "AI, Computational Linguistics, NLP, and digital preservation for reinterpreting Indian knowledge",
    icon: "Computer"
  }
];

export const activities = [
  {
    category: "Meetings & Seminars",
    items: [
      {
        title: "Call for Papers – IKS International Conference 2026",
        date: "March 2026",
        description: "ESubmit your research paper for the International Conference on Indian Knowledge Systems.",
        image: "/assets/PaperCall.png",
        link: "/publications"
      },
      {
        title: "Meeting With Interns",
        date: "Jan 2026",
        description: "First Meeting of Selected Interns – VAC-IKS Student Internship Programme (Jan–June 2026)",
        image: "/assets/UpcomingNotice.webp",
        link: "/assets/UpcomingNotice.webp"
      }
    ]
  },
  {
    category: "Workshops",
    items: [
      {
        title: "Sanskrit Language Intensive",
        duration: "2 Weeks",
        description: "Immersive workshop for learning foundational Sanskrit"
      },
      {
        title: "Ayurveda and Holistic Wellness",
        duration: "1 Week",
        description: "Hands-on training in Ayurvedic principles and practices"
      },
      {
        title: "Digital Humanities Tools",
        duration: "3 Days",
        description: "Technical workshop on computational linguistics and NLP for ancient texts"
      }
    ]
  },
  {
    category: "Public Lectures",
    description: "Regular lectures by eminent scholars, practitioners, and thought leaders in IKS"
  },
  {
    category: "Reading Circle – Vimarśa",
    description: "Student-faculty forum for critical dialogue and engagement with classical texts"
  }
];

export const currentInterns = [
  {
    id: 1,
    name: "Atul Rajput",
    role: "Full Stack Developer Intern",
    duration: "Jan 2026 - Present",
    project: "VAC IKS Website Development",
    linkedin: "https://linkedin.com/in/atulrajput",
    image: "/assets/Atul.jpeg"
  },
  {
    id: 2,
    name: "Rohit Sharma",
    role: "Research Intern",
    duration: "Feb 2026 - Present",
    project: "Indian Knowledge Systems Research",
    linkedin: "https://linkedin.com/in/riya",
    image: "/assets/Atul.jpeg"
  },
  {
    id: 3,
    name: "Aman Verma",
    role: "UI/UX Intern",
    duration: "Jan 2026 - Present",
    project: "Website UI Enhancement",
    linkedin: "https://linkedin.com/in/aman",
    image: "/assets/Atul.jpeg"
  }
];

export const publications = {
  journal: {
    name: "IKS Research Journal",
    frequency: "Bi-Annual",
    description: "An interdisciplinary journal on Indian Knowledge Systems.",
    issn: "XXXX-XXXX (To be assigned)"
  },
  callForPapers: {
    open: true,
    deadline: "April 30, 2026",

    topics: [
      "Language, Literature & Textual Traditions",
      "Psychology & Consciousness Studies",
      "Sciences & Technological Traditions",
      "Mathematics & Computational Traditions",
      "Commerce, Management & Arthashastra",
      "Social & Political Thought",
      "Yoga, Ayurveda & Health Systems",
      "IKS & Digital Humanities",
      "Education & Pedagogy",
      "Environment & Sustainability",
      "Interdisciplinary Approaches"
    ],

    link: "https://forms.gle/AhfzPBhWHm4FQ8JQ8",

    guidelines: "/assets/guidelinesMarch2026.pdf",
    brochure: "/assets/conferenceMarch2026.pdf"
  }
};


export const workWithUs = [
  {
    id: "intern",
    title: "Interns",
    description: "Six-week research internships on contemporary applications of IKS. Work alongside faculty on cutting-edge projects.",
    requirements: [
      "Currently enrolled undergraduate/graduate student",
      "Interest in interdisciplinary research",
      "Basic knowledge of research methodology"
    ],
    benefits: [
      "Certificate of completion",
      "Research publication opportunities",
      "Mentorship from faculty experts"
    ]
  },
  {
    id: "volunteer",
    title: "Volunteers",
    description: "Join our community initiatives, outreach programs, and assist in organizing workshops and events.",
    requirements: [
      "Passion for Indian knowledge systems",
      "Commitment to community service",
      "Good communication skills"
    ],
    benefits: [
      "Certificate of appreciation",
      "Skill development",
      "Networking opportunities"
    ]
  },
  {
    id: "research",
    title: "Research Fellows",
    description: "Opportunities for postgraduate researchers and PhD scholars to conduct advanced research in IKS domains.",
    requirements: [
      "Postgraduate degree in relevant field",
      "Research proposal aligned with Centre's focus",
      "Strong academic credentials"
    ],
    benefits: [
      "Stipend (subject to funding)",
      "Access to resources and facilities",
      "Publication and conference support"
    ]
  },
  {
    id: "collaborate",
    title: "Collaborate With Us",
    description: "We welcome collaborations with institutions, researchers, NGOs, and organizations working in related fields.",
    contact: "vaciks@maitreyi.du.ac.in"
  }
];

export const galleryImages = [
  {
    id: 1,
    category: "event",
    title: "Orientation Session with interns",
    date: "2025",
    image: "/assets/interns-meeting.webp"
  },
  {
    id: 2,
    category: "media",
    title: "VAC-IKS Interns",
    date: "2025",
    image: "/assets/media.jpeg"
  },
  {
    id: 3,
    category: "events",
    title: "Inaugural Ceremony",
    date: "2025",
    image: "/assets/inauguralCeremony.webp"
  },
  {
    id: 4,
    category: "lectures",
    title: "Indian Knowledge Systems",
    date: "2025",
    image: "/assets/iksystem.webp"
  },
  {
    id: 5,
    category: "lectures",
    title: "Distinguished Lecture Series",
    date: "2024",
    image: "/assets/ourLibrary.jpeg"
  },
  {
    id: 6,
    category: "workshops",
    title: "Yoga Workshop",
    date: "2024",
    image: "/assets/yoga.webp"
  },
];

export const mediacoverage = [
  {
    title: "New Centre for Indian Knowledge Systems Launched at Maitreyi College",
    source: "The Times of Education",
    date: "November 2025",
    link: "https://www.maitreyi.ac.in/uploads/news-doc/attachment_file_0_af7074326dadb7cfded5d36981ca2738.pdf"
  },
  {
    title: "Bridging Ancient Wisdom with Modern Education",
    source: "University of Delhi News",
    date: "April 2025",
    link: "https://www.maitreyi.ac.in/uploads/news-doc/attachment_file_0_66fa965b7153a5b5ca8335c6ee9135e2.pdf"
  },
  {
    title: "VAC-IKS: A Pioneer in NEP 2020 Implementation",
    source: "Education Today",
    date: "September 2024",
    link: "https://www.maitreyi.ac.in/uploads/news-doc/attachment_file_0_8af111e159894a7760fadeb0ab6b678a.jpg"
  }
];

export const mediaContent = [
  {
    id: 1,
    type: "youtube",
    title: "IKS Lecture Series",
    date: "March 2026",
    embedUrl: "https://www.youtube.com/embed/t2aPD3Wd228"
  },
  {
    id: 2,
    type: "podcast",
    title: "Podcast with Scholars",
    date: "Feb 2026",
    embedUrl: "https://open.spotify.com/embed/episode/EPISODE_ID"
  },
  {
    id: 3,
    type: "news",
    title: "Featured in The Hindu",
    date: "Jan 2026",
    thumbnail: "/assets/SpritualDialogues.jpeg",
    link: "https://example.com"
    // },
    // {
    //   id: 4,
    //   type: "social",
    //   title: "Instagram Highlight",
    //   date: "March 2026",
    //   thumbnail: "/images/media/social1.jpg",
    //   link: "https://instagram.com"
  }
];

export const announcements = [
  {
    id: 1,
    title: "Applications Open for Certificate Course",
    date: "2025-01-15",
    excerpt: "Enroll now for our 3-month Certificate Course on Foundations of Indian Knowledge Systems",
    link: "/academics#certificate"
  },
  {
    id: 2,
    title: "GYANOTSAVA 2026 – Annual Academic Fest by VAC-IKS",
    date: "2026-04-01",
    excerpt: "Join GYANOTSAVA 2026 featuring Debate (Vāda-Vidyā), Creative Writing (Bhāva-Pravāha), and IKS UG Olympiad. Open to all UG students. Exciting prizes, certificates for all, and inter-college participation welcome. Register before 11 April 2026.",
    link: "/academics"
  },
  {
    id: "3",
    title: "Call for Papers – IKS International Conference 2026",
    excerpt: "Submit your research paper for the International Conference on Indian Knowledge Systems.",
    date: "2026-03-01",
    link: "/publications"
  },
  {
    id: 4,
    title: "Upcoming International Conference",
    date: "2025-03-10",
    excerpt: "Save the date for our Annual International Conference on IKS in March 2025",
    link: "/activities"
  }
];

